import React, { useState } from 'react';
import { PlusIcon } from '@heroicons/react/20/solid';
import Rooms from './Rooms';
import RoomCreationForm from './RoomCreationForm';
import ProfileFeatureWidgetActionMenu from '../Profile/ProfileFeatureWidgetActionMenu';
import SharedRightSlideout from '../Layout/SharedRightSlideout';


const RoomsProfile = ({
  profileType,
  profileId,
  canCreate = false,
  emptyMessage,
  showActionMenu = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="rooms-profile-container">
      {showActionMenu && (
        <div className="rooms-profile-titlebar">
          <h3>Communities</h3>
          <ProfileFeatureWidgetActionMenu
            label="Community actions"
            actions={[
              {
                label: 'Create Room',
                onClick: openModal,
                hidden: !canCreate,
              },
              {
                label: 'Manage Communities',
                disabled: true,
                hidden: !canCreate,
              },
              {
                label: 'Community Settings',
                disabled: true,
                hidden: !canCreate,
              },
              {
                label: 'View Communities',
                href: '#profile-communities-widget',
                hidden: canCreate,
              },
            ]}
          />
        </div>
      )}
      <Rooms
        profileType={profileType}
        profileId={profileId}
        emptyMessage={emptyMessage}
        showRailControls={showActionMenu}
        hideTitle={showActionMenu}
      />
      {canCreate && !showActionMenu && (
        <div className="rooms-profile-create-room-button-row">
          <button
            type="button"
            className="rooms-profile-create-room-button create-product-prompt__button"
            onClick={openModal}
          >
            <PlusIcon aria-hidden="true" className="create-product-prompt__button-icon" />
            Create Room
          </button>
        </div>
      )}

      {canCreate && (
        <SharedRightSlideout
          isOpen={isModalOpen}
          onClose={closeModal}
          title="Create Community"
          subtitle="Add the community name, access, logo, and banner."
          className="room-create-shared-slideout"
          bodyClassName="room-create-shared-slideout-body"
        >
          <RoomCreationForm onClose={closeModal} />
        </SharedRightSlideout>
      )}
    </div>
  );
};

export default RoomsProfile;
